import { render, staticRenderFns } from "./indetailModel.vue?vue&type=template&id=77de9e72&scoped=true"
import script from "./indetailModel.vue?vue&type=script&lang=js"
export * from "./indetailModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de9e72",
  null
  
)

export default component.exports